import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)

if (import.meta.env.VITE_APP_ENV !== 'development' && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment: import.meta.env.VITE_APP_ENV || 'production',
    beforeSend(event) {
      // Ignore errors from the Android app's injected KMP bridge scripts
      const exception = event.exception?.values?.[0]
      const frames = exception?.stacktrace?.frames ?? []
      const isNativeBridgeError =
        exception?.value?.includes('Java exception was raised during method invocation') &&
        frames.some(frame => frame.function?.includes('kmpJsBridge')) &&
        frames.every(frame => frame.filename === '<anonymous>' || frame.filename?.includes('@sentry'))

      return isNativeBridgeError ? null : event
    }
  })
}

app.use(createPinia())
app.use(router)

app.mount('#app')
